/**
 * Start a browser download of a presigned URL.
 *
 * The URL carries `Content-Disposition: attachment`, so a same-tab navigation
 * saves the file and leaves the current page in place. A programmatic anchor
 * click is used instead of `window.open(url, "_blank")`: by the time the
 * presign request has resolved we are outside the user's click stack, and
 * popup blockers (Safari by default, strict Chrome/Firefox settings) silently
 * drop new windows requested from there.
 */
export function openPresignedDownload(url: string): void {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
  }
}
